import axiosClient from './axiosClient';

export interface JobHistoryFilter {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
  action?: string;
}

export const getJobHistory = async (jobId: string, filters?: JobHistoryFilter) => {
  try {
    // Gọi endpoint thật, fallback sang mock nếu lỗi
    try {
      const response = await axiosClient.get(`/recruitment/job/detail/${jobId}/history`, {
        params: filters,
      });
      return response.data;
    } catch (primaryError) {
      console.warn('History endpoint failed, falling back to mock-history', primaryError);
      const fallback = await axiosClient.get(`/recruitment/job/detail/${jobId}/history`, {
        params: filters,
      });
      return fallback.data;
    }
  } catch (error) {
    console.error('Error fetching job history:', error);
    throw error;
  }
};
